import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

new Vue({
  vuetify,
  render: h => h(App, {
    props: {
      callback: (args) => window.sendDevis(args)
    }
  })
}).$mount('#app')
